import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import { SteeringWheelSpinner } from 'Views/Components/_HumanWritten/Lottie/SteeringWheelSpinner';

export function WaitingReservationLoader() {
	return (
		<div className="post-payment__wrap">
			<SteeringWheelSpinner postPayment />
			<h2 className="post-payment__header">
				<FormattedMessage
					id="booking-wizard__reservation-loader__header"
					defaultMessage="Processing Reservation"
				/>
			</h2>
			<h5 className="post-payment__subheader">
				<FormattedMessage
					id="booking-wizard__reservation-loader__subheader"
					defaultMessage="Preparing your cart"
				/>
			</h5>
			<p className="post-payment__text">
				<FormattedMessage
					id="booking-wizard__reservation-loader__description"
					defaultMessage="<strong>Please keep this window open</strong>—we'll send you directly to checkout once finished. Contact us if you are waiting longer than 5 minutes."
					values={{ strong: (chunks: React.ReactNode) => <strong>{chunks}</strong> }}
				/>
			</p>
		</div>
	);
}
